import { type RootState } from '@/state';

export const isAppLoading = ({ loader: { pendingCalls } }: RootState) =>
  Object.values(pendingCalls).some(Boolean);
